// extracted by mini-css-extract-plugin
export var dates = "openings-module--dates--99a7f";
export var days = "openings-module--days--4dce0";
export var hours = "openings-module--hours--fe761";
export var listWrapper = "openings-module--listWrapper--03492";
export var oneDayWrapper = "openings-module--oneDayWrapper--8d03d";